/**
 * Stepper progress indicator for sign up flow
 */
import React from 'react';
import PropTypes from 'prop-types';
import Classnames from 'classnames';
import { withStyles } from '@material-ui/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

const propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    activeStep: PropTypes.string.isRequired,
  }).isRequired,
  className: PropTypes.string,
  activeStepIndex: PropTypes.oneOf([0, 1, 2]),
};

const defaultProps = {
  className: null,
  activeStepIndex: 0,
};

export function UnstyledSignUpProgress({ classes, className, activeStepIndex }) {
  const iconProps = {
    classes: {
      active: classes.activeStep,
    },
  };
  return (
    <Stepper className={Classnames(className, classes.root)} activeStep={activeStepIndex}>
      <Step>
        <StepLabel StepIconProps={iconProps}>Verify Email</StepLabel>
      </Step>
      <Step>
        <StepLabel StepIconProps={iconProps}>Organization Information</StepLabel>
      </Step>
    </Stepper>
  );
}

UnstyledSignUpProgress.propTypes = propTypes;
UnstyledSignUpProgress.defaultProps = defaultProps;

const styles = (theme) => ({
  root: {
    '& $activeStep': {
      color: theme.customColors.orange,
      '& text': {
        fill: theme.customColors.white,
      },
    },
  },
  activeStep: {},
});

export default withStyles(styles)(UnstyledSignUpProgress);
